import { type ChainId, getChainById } from 'sushi'
import { isSushiSwapChainId } from 'sushi/evm'

export const getNetworkName = (network: ChainId) => {
  return getChainById(network).name
}

export const replaceNetworkSlug = (_network: ChainId, pathname: string) => {
  if (pathname.includes('/pool/')) {
    return '/explore/pools'
  }
  if (pathname.includes('/token/')) {
    if (isSushiSwapChainId(_network)) {
      return '/explore/tokens'
    }
    return '/explore/pools'
  }
  // Strip the chain prefix segment if present
  const pathSegments = pathname.split('/')
  if (pathSegments.length > 1) {
    pathSegments.splice(1, 1)
  }
  return pathSegments.join('/') || '/'
}
